import React from 'react';
import NicejobAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/NicejobAppIcon';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import GenericAppButton from '../OtherComponents/GenericAppButton';
import { NICE_JOB } from '../AppsData';

const NiceJobStrategy = {
  previewInfo: {
    name: 'NiceJob',
    iconSvg: <NicejobAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'NiceJob',
    category: 'Online review generation',
    details: 'NiceJob is the easiest way to get more great reviews and build your reputation. On average, in just 3 months companies double their reviews with NiceJob.',
    iconSvg: <NicejobAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'Why do NiceJob Clients Win More Sales?',
    bottomDescription: 'Try NiceJob for free for 14 days, and get the reputation you deserve.',
    unorderedPoints: [
      'NiceJob get you more reviews, and reviews win customers.',
      'NiceJob automates your social media marketing using your customer stories, which builds trust, drives website traffic, and wins sales.',
      'NiceJob publishes your reviews to your website, improving your search engine rankings, website traffic, and website conversion rate.',
    ],
  },
  price: {
    price: '',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1" color="textSecondary">
            Standard
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            $75/mo & no setup fees
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    appActionButton: <GenericAppButton app={NICE_JOB} name="NiceJob" url="https://nicejob.com/" />,
  },
  supportContacts: [
    { type: 'email', contact: 'hello@nicejob.com' },
    { type: 'phone', contact: '888-336-9082' },
  ],
};

export default NiceJobStrategy;
